/**
 * Get all text nodes the given node contains.
 * @param node Parent that is search for text nodes.
 */
export function getTextNodes(node: Node): Node[] {
  const nodes: Node[] = [];

  if (node.nodeType === Node.TEXT_NODE) {
    nodes.push(node);
  } else {
    nodes.push(
      ...Array.prototype.slice
        .call(node.childNodes)
        .map(getTextNodes)
        .reduce((a, b) => a.concat(b), [])
    );
  }

  return nodes;
}
